<template>
  <div class="skxRzsx">
    <van-nav-bar :title="'入职筛选'" left-arrow @click-left="onClickLeft">
    </van-nav-bar>
    <div class="top">
      <div class="title">
        {{ data.empname }}({{ data.crman }})发起劳务申请单申请({{
          data.crdate
        }})
      </div>
      <van-row>
        <van-col span="12"
          ><van-cell title="工作类型" :value="data.labortype"
        /></van-col>
        <van-col span="12"
          ><van-cell title="技术工种" :value="data.skilltype"
        /></van-col>
      </van-row>
      <van-row>
        <van-col span="12"
          ><van-cell title="需要人数" :value="data.reqnumber"
        /></van-col>
        <van-col span="12"
          ><van-cell title="已招人数">
            {{ num }}
            <span style="color:#1890ff;"
              ><van-icon name="replay" @click="change()"
            /></span>
          </van-cell>
        </van-col>
      </van-row>
      <div class="detail">
        <span v-for="(item, i) in list" :key="i" class="labor">
          ·{{ item.labor_source }}:
          <span class="labor_source_number"
            >{{ item.num }}/{{ item.labor_source_number }}</span
          ></span
        >
      </div>
    </div>
    <van-tabs v-model="active">
      <van-tab title="二维码">
        <div class="deptname">{{ data.yg_deptname }}</div>
        <div class="box">
          <qrcode :text="QRCode" :width="200" :height="200" />
        </div>
      </van-tab>
      <van-tab :title="'已选（' + num + '）'">
        <van-search v-model="seachstr" placeholder="请输入搜索关键词" />
        <div class="detailList" v-for="item in detailList" :key="item.empid">
          <div class="main">
            <div class="l">
              <van-image
                round
                width="60px"
                height="60px"
                azy-load
                :src="item.src"
              />
              <div class="m">
                <div class="m-top">{{ item.empname }}({{ item.restype }})</div>
                <div class="m-bottom">
                  <van-tag round type="primary" size="medium"
                    >{{ item.sex }}{{ item.age }}</van-tag
                  >
                  <van-tag round type="primary" size="medium">{{
                    data.labortype
                  }}</van-tag>
                  <van-tag round type="primary" size="medium">{{
                    data.skilltype
                  }}</van-tag>
                </div>
              </div>
            </div>
            <div class="r">
              <van-tag
                round
                size="large"
                :color="item.status == '已入职' ? '#d5ffe9' : '#ffe9e9'"
                :text-color="item.status == '已入职' ? '#07c160' : '#ff1818'"
                >{{ item.status }}</van-tag
              >
              <van-button size="mini" type="danger" @click="qxrz(item)"
                >取消入职</van-button
              >
            </div>
          </div>
          <div class="history" v-if="item.org_name">
            <van-cell title="历史服务组织"> {{ item.org_name }} </van-cell>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import qrcode from '@components/qrcode'
import {
  getReq,
  getDynV8ApiToken,
  getdecode,
  getScanEntryUrl,
  getCapPicPath
} from '@api/wx.js'
import { getDownLoadFileName } from '@api/wxzp.js'
import { Dialog, Toast, Notify } from 'vant'
export default {
  components: {
    qrcode
  },
  data() {
     const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    return {
      userInfo,
      QRCode: 'tetetrt',
      v8apitoken: '',
      listno: '',
      query: '',
      data: {},
      list: [],
      tableData: [],
      active: 0,
      num: 0,
      seachstr: '',
      CapPicpath: 'CapPic'
    }
  },
  mounted() {
    this.ini()
  },
  computed: {
    detailList() {
      return this.tableData.filter(e => {
        return e.empname.indexOf(this.seachstr) > -1
      })
    }
  },
  methods: {
    onClickLeft() {
      this.$router.push({
        path: '/workFlow',
        query: this.query
      })
    },
    ini() {
      this.listno = this.$route.query.listno
      this.query = this.$route.query.query
      getDynV8ApiToken().then(res => {
        // 获取v8apitoken 后面自定义接口用到
        this.v8apitoken = res
        this.getInfo()
      })
      this._getCapPicPath()
    },
    getInfo() {
      getReq(
        {
          autoid: 0,
          fixcode: '3a10ebddf6244c51a24080515479a512',
          p01: this.listno
        },
        this.v8apitoken
      ).then(res => {        
        if(res.data[0].info){
          Toast(res.data[0].info);
        }else{
          this.data = res.data[0]
          this.list = res.list
          // this.list = [
          //   { labor_source: '宜好', labor_source_number: 2 },
          //   { labor_source: '明岛', labor_source_number: 2 },
          //   { labor_source: '长乐', labor_source_number: 2 }
          // ]
          this.list.forEach(element => {
            element.num = 0
          })
          this._getdecode()
        }        
      })
    },
    _getdecode() {
      getScanEntryUrl().then(res => {
        if (this.$getObject(res) == 'String') {
          this.QRCode =
            res +
            '/scanEntry?module=' +
            this.data.module +
            '&tj_empid=' +
            this.data.autoid
        }
      })
      this.change()
    },
    change() {
      getReq(
        {
          autoid: 0,
          fixcode: '3708ec609932446dbfd34afe4a2ec0a0',
          p01: this.listno
        },
        this.v8apitoken
      ).then(res => {
        this.tableData = res.data
        this.num = this.tableData.length
        this.list.forEach(element => {
          element.num = 0
        })
        this.tableData.forEach(element => {
          this.getDownLoadFileNameData(element)
          res.data2.forEach(item => {
            if (item.empid == element.empid) {
              element.org_name = item.org_name
            }
          })
          this.list.forEach(e => {
            if (element.restype == e.labor_source) {
              e.num++
            }
          })
        })
        console.log(this.tableData, '1111')
      })
    },
    qxrz(item) {
      // console.log(item);
      
      Dialog.confirm({
        title: '系统提示',
        message: '你确定要取消入职吗？'
      }).then(() => {
        getReq(
          {
            autoid: 0,
            fixcode: '2d8aa241cf9643a08be66cc6224a140b',
            p01: item.autoid,
            p02: this.userInfo.username,
          },
          this.v8apitoken
        ).then(res => {
           this.change()
          if(res.data.length>0){
            if(res.data[0].isinfo){
              Toast(res.data[0].info);
            }
          }         
        })
      })
    },
    _getCapPicPath() {
      getCapPicPath().then(res => {
        this.CapPicpath = res
      })
    },
    getDownLoadFileNameData(element) {
      getDownLoadFileName({
        dflag: 5,
        moduleno: 201,
        autoid: element.empid,
        filename: 'CapPic',
        fileext: '.jpg',
        file_name_guid: '',
        downloadpath: this.CapPicpath
      }).then(res => {
        element.src = res + '?v=' + Date.parse(new Date())
        console.log(element)
        this.$forceUpdate()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.skxRzsx {
  .van-nav-bar {
    background: #2b8df0;
    height: 92px;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
    ::v-deep .van-nav-bar__right {
      .van-nav-bar__text {
        color: #fff;
        font-family: Source Han Sans CN;
      }
    }
  }
  .top {
    box-shadow: 0 0 0.26667rem rgba(0, 0, 0, 0.23);
    background: #fff;
    border-radius: 0.21333rem;
    margin: 0 0.4rem;
    margin-top: 0.53333rem;
    padding: 10px 20px;
    .title {
      font-size: 30px;
      margin-bottom: 20px;
    }
    .van-row {
      .van-cell {
        font-size: 26px;
        .van-cell__title {
          color: #666;
        }
        .van-cell__value {
          text-align: left;
          color: #000;
        }
      }
    }
    .detail {
      font-size: 26px;
      .labor {
        color: #666;
        margin-right: 20px;
        .labor_source_number {
          color: #000;
        }
      }
    }
  }
  .van-tabs {
    box-shadow: 0 0 0.26667rem rgba(0, 0, 0, 0.23);
    background: #fff;
    border-radius: 0.21333rem;
    margin: 0 0.4rem;
    margin-top: 0.53333rem;
    padding: 10px 20px;
    .deptname {
      color: #fff !important;
      background: #1890ff !important;
      font-size: 40px;
      text-align: center;
      padding: 10px 0;
    }

    .box {
      margin: 30px 0;
    }
    .detailList {
      padding: 10px;
      margin-bottom: 20px;
      .main {
        display: flex;
        justify-content: space-between;
        .l {
          display: flex;
          justify-content: start;
          .m {
            margin-left: 10px;
            .m-top {
              font-size: 30px;
              margin-bottom: 10px;
            }
            .m-bottom {
              .van-tag {
                margin-right: 10px;
              }
            }
          }
        }
        .r {
          width: 120px;
        }
      }
    }
  }
}
</style>
